var _defs, _g;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgTwitterLogoTeal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 415.42 320.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#00857c;stroke-miterlimit:10;stroke-width:15px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\xEB\\xEE\\xE9_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M207.7,101.53C113.48,99.15,49.66,22.21,49.66,22.21c0,0-32.5,61.73,22.96,101.53,0,0-15.35,1.34-32.42-8.5,0,0-6.64,57.25,58.67,75.44,0,0-4.32,4.77-31.91,2.53,0,0,13.49,50.62,69.85,52.18,0,0-34.66,37.35-110.26,33.32,0,0,119.87,81.18,247.02-7.22,43.15-30,94.49-112.42,87.4-187.87,0,0,23.26-14.91,37.12-39.21,0,0-9.99,4.11-20.37,7.07-8.59,2.45-17.44,3.83-21.08,3.97,0,0,28.48-19.68,31.61-41.75,0,0-31.09,16.91-47.34,18.13l-.56,.04c-14.07-14.92-34.03-24.24-56.16-24.24-42.63,0-77.19,34.56-77.19,77.19,0,5.73,.63,11.32,1.81,16.7h-1.11Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterLogoTeal);
export default __webpack_public_path__ + "static/media/twitter-logo-teal.169506cfec985042112f5a3587ac0a90.svg";
export { ForwardRef as ReactComponent };